import useAuthTabSwitch from "@casino/legacy/client/components/Auth/Shared/useAuthTabSwitch";
import useLink from "@casino/legacy/client/components/Auth/Shared/useLink";
import Translate from "@casino/legacy/client/shared/i18n/Translate";
import NextLink from "@casino/legacy/client/shared/NextLink";
import { useRouter } from "next/navigation";
import AlreadyHaveAccountLinkBody from "./AlreadyHaveAccountLinkBody";

type Props = {
  isPopover?: boolean;
};
const AlreadyHaveAccountLink: FC<Props> = ({ isPopover }) => {
  const { href } = useLink("login");
  const switchTab = useAuthTabSwitch();
  const router = useRouter();

  if (isPopover) {
    return (
      <AlreadyHaveAccountLinkBody>
        <div
          className="cursor-pointer text-primary"
          onClick={() => switchTab("login")}
        >
          <Translate id="profile.login" />
        </div>
      </AlreadyHaveAccountLinkBody>
    );
  }
  return (
    <AlreadyHaveAccountLinkBody>
      <NextLink href={href} onTouchEnd={() => router.replace(href.pathname)}>
        <p className="text-sm leading-6 text-primary">
          <Translate id="profile.login" />
        </p>
      </NextLink>
    </AlreadyHaveAccountLinkBody>
  );
};

export default AlreadyHaveAccountLink;
